import type { Components, Theme } from '@mui/material';

import { colors } from '@verantos-dev/shared-ui-components/tokens';

const appBarThemeConfig: Components<Theme>['MuiAppBar'] = {
  styleOverrides: {
    root: {
      backgroundColor: colors['primary-700'],
      height: '51px',
      minHeight: '51px',
    },
  },
};

const toolbarThemeConfig: Components<Theme>['MuiToolbar'] = {
  styleOverrides: {
    regular: {
      height: '51px !important',
      minHeight: '51px !important',
    },
  },
};

export const muiAppBarThemeConfig = {
  MuiAppBar: {
    ...appBarThemeConfig,
  },
  MuiToolbar: {
    ...toolbarThemeConfig,
  },
};
